export const ExpandIcon = ({
  width = 15,
  height = 15,
  rotationDegree = 0,
  color = "currentColor",
  className = "",
}) => {
  const style = {
    transform: `rotate(${rotationDegree}deg)`,
    transition: "transform 0.15s ease-in-out",
  };

  return (
    <svg
      className={className}
      fill={color}
      height={height}
      width={width}
      style={style}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z" />
    </svg>
  );
};
